'use client';

import React from 'react';
import Hero, { HeroProps } from 'components/commercetools-ui/organisms/content/hero';
import { TasticProps } from 'frontastic/tastics/types';

const HeroTastic = ({ data }: TasticProps<HeroProps>) => {
  return <Hero data={data?.data?.dataSource} />;
};

export default HeroTastic;